import { jsx as c, jsxs as i, Fragment as p } from "react/jsx-runtime";
import { d as g, aL as f } from "../../vendor-CPVnY93G.js";
import { forwardRef as b } from "react";
import { stupidInvertClasses as h } from "../../utils/index.js";
import { getButtonStyles as u } from "../BaseButton/index.js";
import { BaseIcon as y } from "../BaseIcon/index.js";
import { isIconName as B } from "../BaseIcon/typeGuards.js";
import { withTooltip as k } from "../Tooltip/withTooltip.js";
import { omitStyleRenderProps as x } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index62.css';const L = "_toggleButton_1c8m9_1", $ = "_secondary_1c8m9_10", I = "_heart_1c8m9_18", T = "_pin_1c8m9_19", j = "_bookmark_1c8m9_20", v = "_star_1c8m9_21", w = "_sm_1c8m9_52", N = "_hasLabel_1c8m9_52", R = "_md_1c8m9_56", t = {
  toggleButton: L,
  secondary: $,
  heart: I,
  pin: T,
  bookmark: j,
  star: v,
  sm: w,
  hasLabel: N,
  md: R
}, H = k(
  b(
    ({
      size: s = "md",
      variant: o = "secondary",
      __inverted: n,
      children: r,
      icon: a,
      ...e
    }, _) => {
      const d = g(
        u({
          size: s,
          variant: o === "secondary" ? "secondary" : "ghost",
          ...e
        }),
        t.toggleButton,
        r ? t.hasLabel : void 0,
        t[o],
        t[s],
        n ? h() : void 0
      );
      return /* @__PURE__ */ c(
        f,
        {
          ...x(e),
          className: d,
          ref: _,
          "data-component": "ToggleButton",
          children: ({ isSelected: l }) => {
            const m = o === "secondary" ? a : `${o}${l ? "-filled" : ""}`;
            return /* @__PURE__ */ i(p, { children: [
              B(m) && /* @__PURE__ */ c(y, { icon: m, size: s }),
              r
            ] });
          }
        }
      );
    }
  )
);
export {
  H as ToggleButton
};
